module.exports = __webpack_public_path__ + "img/common_statEMP.10b99771.svg";